__turbopack_context__.v({
  "className": "poppins_3a3dfacd-module__1LdNGW__className",
});
